import React from 'react';
import type { TFunction } from 'i18next';
import type { ReactNode } from 'react';
import { TaskCategory } from '../../types/enums';
import { TranslationKey } from '../../i18n/translationKeys';
import { IconEmail } from '../../assets/icons/IconEmail';

export const CATEGORY_ROUTE_PREFIX: Record<TaskCategory, string> = {
    [TaskCategory.CUSTOMER_RELANCE]: '/customer-follow-up',
    [TaskCategory.MISSING_DATA]: '/not-found',
    [TaskCategory.OTHER]: '/not-found',
};

export function getCategoryRoutePrefix(category: TaskCategory): string {
    return CATEGORY_ROUTE_PREFIX[category] ?? '/not-found';
}

export const CATEGORY_LABEL_KEY: Record<TaskCategory, string> = {
    [TaskCategory.CUSTOMER_RELANCE]: TranslationKey.TaskCategories.CustomerRelance,
    [TaskCategory.MISSING_DATA]: TranslationKey.TaskCategories.MissingData,
    [TaskCategory.OTHER]: TranslationKey.TaskCategories.Other,
};

export function getCategoryLabel(category: TaskCategory, t: TFunction): string {
    const key = CATEGORY_LABEL_KEY[category];
    return key ? t(key) : category;
}

export function getCategoryIcon(category: TaskCategory): ReactNode {
    switch (category) {
        case TaskCategory.CUSTOMER_RELANCE: return React.createElement(IconEmail);
        default: return null;
    }
}
